module.exports = __webpack_public_path__ + "img/card_ip_stipulation34.91f078f6.svg";